import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDtYPw5ENCN7Dy8ZMyOMFzy6GyyfIlEd2o",
  authDomain: "tomuerp-fb96d.firebaseapp.com",
  projectId: "tomuerp-fb96d",
  storageBucket: "tomuerp-fb96d.firebasestorage.app",
  messagingSenderId: "215520048178",
  appId: "1:215520048178:web:7fb0b2e5cb2de41a4bb82b",
  measurementId: "G-1JMFELLTYK"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };